import React, { useEffect, useState } from 'react';
import './Gallery.css'
import Masonry from '../Components/Layout/GalGrid';


import StaggeredMenu from '../Components/Layout/StaggeredMenu';
import Footer from '../Components/Layout/Footer';
import { supabase } from '../supabase';

const Gallery = () => {

    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
        const fetchGalleryImages = async () => {
            try {
                const { data, error } = await supabase
                    .from('gallery')
                    .select('*');

                if (error) throw error;

                const heights = [400, 700, 600, 500]; 
                
                const formattedImages = data.map((row, index) => ({
                    id: row.id.toString(),
                    img: row.img_url,
                    url: "",          
                    height: heights[index % heights.length], 
                }));

                setItems(formattedImages);
            } catch (err) {
                console.error("Error loading gallery assets:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchGalleryImages();
    }, []);


const menuItems = [
        { label: 'Home', ariaLabel: 'Go to home page', link: '/' },
        { label: 'Booking', ariaLabel: 'Learn about us', link: '/booking' },
        { label: 'Gallery', ariaLabel: 'Get in touch', link: '/gallery' }
      ];
    return ( <>

        <StaggeredMenu
                    position="right"
                    items={menuItems}
                    displaySocials
                    displayItemNumbering={true}
                    menuButtonColor="#3A3A3A"
                    openMenuButtonColor="#3A3A3A"
                    changeMenuColorOnOpen={true}
                    colors={['#35A44F', '#21FF55']}
                    logoUrl='../Assets/Imgs/Logo.svg'
                    accentColor="#35A44F"
                    onMenuOpen={() => console.log('Menu opened')}
                    onMenuClose={() => console.log('Menu closed')}
                />

        <main className='Gallery'>
            <p className='SectionTitle'>GALLERY</p>

           {loading ? (
                    <div className="Loader" style={{color: '#21FF55', textAlign: 'center', padding: '50px'}}>
                        Streaming Assets...
                    </div>
                ) : (
                    <Masonry
                        items={items}
                        ease="power3.out"
                        duration={0.6}
                        stagger={0.05}
                        animateFrom="bottom"
                        scaleOnHover={false}
                        hoverScale={0.95}
                        blurToFocus
                        colorShiftOnHover
                    />
                )}
        </main>
        <Footer/>
    </> );
}
 
export default Gallery;